import { useParams, usePathname } from 'next/navigation';

type UsePathname = ReturnType<typeof usePathname>;
type UseParams = ReturnType<typeof useParams>;

/**
 * Works out what the current bloomreach page type is based on the NextJS path and URL params.
 * @see https://nextjs.org/docs/app/api-reference/functions/use-pathname
 * @see https://nextjs.org/docs/app/api-reference/functions/use-params
 */
const getPageType = (pathName: UsePathname, params: UseParams) => {
    // Simple path name match checking.
    switch (pathName) {
        case '/':
            return 'homepage';
        case '/order-confirmed':
            return 'orderConfirmed';
        case '/search-results':
            return 'search';
        default:
            break;
    }

    // If its a condition or generic page. Condition or generic pages only have one URL param which is
    // the dynamicRoute.
    if (params?.dynamicRoute && Object.keys(params).length === 1) {
        return 'category';
    }

    // If its a product page. Product pages have two URL params, dynamicRoute and treatmentSlug.
    if (params?.dynamicRoute && params?.treatmentSlug && Object.keys(params).length === 2) {
        return 'product';
    }

    return 'other';
};

export default getPageType;
